<template>
  <div class="signIn">
    <SignInForm />
  </div>
</template>

<script>
import SignInForm from "@/views/SignInForm.vue";

export default {
  components: {
    SignInForm,
  },
  mounted () {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
</style>
